import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import NewsEditor from './NewsEditor';
import '../styles/AdminPanel.css';

const AdminPanel = () => {
    const { user, isEditor } = useAuth();
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showEditor, setShowEditor] = useState(false);
    const [editingNews, setEditingNews] = useState(null);
    const [currentView, setCurrentView] = useState('list');

    useEffect(() => {
        if (isEditor()) {
            fetchNews();
        }
    }, []);

    const fetchNews = async () => {
        try {
            const response = await fetch(`/api/news/admin/all?userId=${user.id}`);
            const data = await response.json();
            if (data.success) {
                setNews(data.news);
            }
        } catch (error) {
            console.error('Error fetching news:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (newsItem) => {
        setEditingNews(newsItem);
        setShowEditor(true);
        setCurrentView('editor');
    };

    const handleCreate = () => {
        setEditingNews(null);
        setShowEditor(true);
        setCurrentView('editor');
    };

    const handleDelete = async (id) => {
        if (window.confirm('¿Estás seguro de que deseas eliminar esta noticia?')) {
            try {
                const response = await fetch(`/api/news/${id}?userId=${user.id}`, {
                    method: 'DELETE',
                });
                const data = await response.json();
                if (data.success) {
                    fetchNews();
                    alert('Noticia eliminada exitosamente');
                } else {
                    alert('Error eliminando la noticia');
                }
            } catch (error) {
                console.error('Error deleting news:', error);
                alert('Error eliminando la noticia');
            }
        }
    };

    const handleSave = () => {
        fetchNews();
        setShowEditor(false);
        setEditingNews(null);
        setCurrentView('list');
    };

    const handleCancel = () => {
        setShowEditor(false);
        setEditingNews(null);
        setCurrentView('list');
    };

    if (!isEditor()) {
        return (
            <div className="admin-panel">
                <h2>Acceso Denegado</h2>
                <p>No tienes permisos para acceder a esta sección.</p>
            </div>
        );
    }

    if (loading) {
        return (
            <div className="admin-panel">
                <h2>Cargando...</h2>
            </div>
        );
    }

    return (
        <div className="admin-panel">
            <div className="admin-header">
                <h2>Panel de Administración - Noticias</h2>
                <div className="admin-nav">
                    <button 
                        className={currentView === 'list' ? 'active' : ''}
                        onClick={() => setCurrentView('list')}
                    >
                        Lista de Noticias
                    </button>
                    <button 
                        className="create-btn"
                        onClick={handleCreate}
                    >
                        + Nueva Noticia
                    </button>
                </div>
            </div>

            {currentView === 'list' && (
                <div className="news-list">
                    {news.length === 0 ? (
                        <div className="no-news">
                            <p>No hay noticias publicadas</p>
                            <button className="create-btn" onClick={handleCreate}>
                                Crear primera noticia
                            </button>
                        </div>
                    ) : (
                        <div className="news-grid">
                            {news.map((newsItem) => (
                                <div key={newsItem.id} className="news-item">
                                    <div className="news-item-header">
                                        <h3>{newsItem.title}</h3>
                                        <div className="news-actions">
                                            <button 
                                                className="edit-btn"
                                                onClick={() => handleEdit(newsItem)}
                                            >
                                                Editar
                                            </button>
                                            <button 
                                                className="delete-btn"
                                                onClick={() => handleDelete(newsItem.id)}
                                            >
                                                Eliminar
                                            </button>
                                        </div>
                                    </div>
                                    <div className="news-item-summary">
                                        {newsItem.summary}
                                    </div>
                                    <div className="news-item-meta">
                                        <span>Por: {newsItem.author_name}</span>
                                        <span>
                                            {new Date(newsItem.created_at).toLocaleDateString()}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {currentView === 'editor' && (
                <NewsEditor
                    news={editingNews}
                    onSave={handleSave}
                    onCancel={handleCancel}
                />
            )}
        </div>
    );
};

export default AdminPanel;
